import { NavLink as RouterNavLink } from 'react-router-dom';
import type { Icon } from '@phosphor-icons/react';
import {
  SquaresFour,
  GithubLogo,
  MagnifyingGlass,
  Gear,
  BookOpen,
  Stack,
  Heartbeat,
  Graph,
} from '@phosphor-icons/react';

const ICONS: Record<string, Icon> = {
  overview: SquaresFour,
  repositories: GithubLogo,
  'sync-issues': Heartbeat,
  search: MagnifyingGlass,
  settings: Gear,
  docs: BookOpen,
  library: Stack,
  graph: Graph,
};

interface NavLinkProps {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}

export function NavLink({ to, label, icon, end }: NavLinkProps) {
  const IconComponent = ICONS[icon] ?? SquaresFour;
  return (
    <RouterNavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        [
          'flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13.5px] transition-colors duration-100',
          isActive
            ? 'bg-overlay/10 text-text font-semibold'
            : 'text-text/50 hover:text-text/85 hover:bg-overlay/5 font-medium',
        ].join(' ')
      }
    >
      {({ isActive }) => (
        <>
          <IconComponent size={15} weight={isActive ? 'fill' : 'regular'} />
          <span>{label}</span>
        </>
      )}
    </RouterNavLink>
  );
}
